import React from 'react'

export default function LouisVuitton({ className }) {
  return (
    <svg viewBox="0 0 154.65 150.8" className={className}>
      <path
        fill="currentColor"
        d="M124.8 19.54l-40.16 94.79-11.08-24.31 20.47-55.71c1.54-4.31 6.92-6.31 16-6.31l3.23-8.46h-47.7L62.48 28c6.77 0 9.54 2 8.46 6.31L60.78 62.63l-20-43.09c-3.69-4.62-1.85-6.92 5.39-6.92v-10H0v10c8.62 0 14 2.31 16.31 6.92l33.85 72.02-15.85 42.32c-.31 5.69-9.23 8.46-26.47 8.46l-3.23 8.46h131.72l18.31-38.93h-9.54c-8.93 20.16-19.24 30.47-30.78 30.47H53.86l8.93-23.85 7.69 15.39h17.23l48.63-114.33c2.31-6.92 8.31-10.62 17.7-10.62V0h-39.7v8.93c12 0 15.38 3.69 10.46 10.61z"
      />
    </svg>
  )
}
